import clsx from "clsx";
import { useForm as useFormHook } from "hooks";
// import useValidationSchema from "./useValidationSchema";
import type { HighRiskMerchant } from 'features/ecommerce/types';
import {
    FormField,
    type OnboardingMarketingWebsiteAndSupport,
    type OnboardingMarketingWebsiteAndSupportForm
} from "./types";

export const getInitialValues = ({
    membershipPackagesInput,
    freeTrialInput,
    marketingMethods,
    targetCountries,
    forAnotherBusinessInput,
    providingServicesToNotOwnedSitesInput,
    hasMembershipPackages = null,
    hasFreeTrial = null,
    hasTangibleGoods = null,
    isProvidingServicesToNotOwnedSites = null,
    hasWebsiteOwnerControl = null,
    isForAnotherBusiness = null,
}: Partial<HighRiskMerchant.OnboardingMarketingWebsiteAndSupport>): OnboardingMarketingWebsiteAndSupport => ({
    [FormField.HasMembershipPackages]: hasMembershipPackages,
    [FormField.MembershipPackagesInput]: clsx(membershipPackagesInput),
    [FormField.HasFreeTrial]: hasFreeTrial,
    [FormField.FreeTrialInput]: clsx(freeTrialInput),
    [FormField.HasTangibleGoods]: hasTangibleGoods,
    [FormField.MarketingMethods]: clsx(marketingMethods),
    [FormField.TargetCountries]: clsx(targetCountries),
    [FormField.HasWebsiteOwnerControl]: hasWebsiteOwnerControl,
    [FormField.IsForAnotherBusiness]: isForAnotherBusiness,
    [FormField.ForAnotherBusinessInput]: clsx(forAnotherBusinessInput),
    [FormField.IsProvidingServicesToNotOwnedSites]: isProvidingServicesToNotOwnedSites,
    [FormField.ProvidingServicesToNotOwnedSitesInput]: clsx(providingServicesToNotOwnedSitesInput)
});

export const useForm = (onboardingMarketingWebsiteAndSupport: OnboardingMarketingWebsiteAndSupportForm) =>
    useFormHook({
        isInitialValid: false,
        ...onboardingMarketingWebsiteAndSupport,
        validateOnMount: true,
        // validationSchema: useValidationSchema()
    });
